import SilderMulti from "./Sliders/SilderMulti";


export default function Systems({ title, description, systems }) {
  return (
    <div className="mx-2 md:mx-10 lg:mx-10">
        <div className="text-right">
            <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
            <p className="text-xl text-primary mb-10 ml-0 lg:ml-40">{description}</p>
        </div>   
        <SilderMulti items={systems} />
    </div>
  );
}
